import i18n from '@/i18n';

export const mainNavItems = [
  {
    name: i18n.t('sidebar.eventLog'),
    url: '/',
  },
  {
    name: i18n.t('sidebar.technicalMonitoring'),
    url: '/technical-alarm',
  },
  {
    name: i18n.t('sidebar.statistics'),
    url: '/statistics',
  },
];

export const userSettingsNavItems = [
  {
    name: 'Profile',
    url: '/me/profile',
    icon: 'fas fa-user',
  },
];

function isManager(
  userProfile: string[],
  tenant: { name: string; group: string }
): boolean {
  if (userProfile.includes('admin')) {
    return true;
  }

  if (tenant) {
    if (
      userProfile.includes(`${tenant.group}-${tenant.name}-gestionnaire`) ||
      userProfile.includes(`${tenant.group}-${tenant.name}-admin`)
    ) {
      return true;
    }
  }

  return false;
}

function isAdmin(
  userProfile: string[],
  tenant: { name: string; group: string }
): boolean {
  if (userProfile.includes('admin')) {
    return true;
  }

  if (tenant) {
    if (userProfile.includes(`${tenant.group}-${tenant.name}-admin`)) {
      return true;
    }
  }

  return false;
}

export const getNavItemsFromRoute = (
  path: string,
  isPlatformAdminMenuShowed: boolean,
  currentUserProfile: any,
  currentTenant: any
) => {
  if (path.substr(0, 4) === '/me/') {
    return userSettingsNavItems;
  }

  const children = [];
  if (isManager(currentUserProfile, currentTenant)) {
    children.push(
      {
        name: i18n.t('sidebar.users'),
        url: '/admin/users',
        icon: 'fas fa-users-cog',
      },
      {
        name: i18n.t('sidebar.residences'),
        url: '/platform-management/residencies',
        icon: 'fas fa-database',
      }
    );
  }
  if (isAdmin(currentUserProfile, currentTenant)) {
    children.push(
      {
        name: i18n.t('sidebar.agencies'),
        url: '/platform-management/tenants',
        icon: 'fas fa-database',
      },
      {
        name: i18n.t('sidebar.authLog'),
        url: '/admin/logs/auth',
        icon: 'fas fa-book',
      }
    );
  }
  if (children.length) {
    return [
      ...mainNavItems,
      {
        name: i18n.t('sidebar.administration'),
        icon: 'fas fa-unlock-alt',
        isToggle: false,
        children,
      },
    ];
  }
  return mainNavItems;
};
